import React from 'react';
import { Typography } from '@navi/web-ui/lib/primitives';
import LinkIcon from '@cp/src/assets/icons/LinkIcon';
import { getReportTypeDisplayName, getTeamTypeDisplayName, handleRedirection } from '../utils';

interface ConfigDrawerInfoProps {
  baseReportType: string;
  teamType: string;
}

const ConfigDrawerInfo: React.FC<ConfigDrawerInfoProps> = ({ baseReportType, teamType }) => {
  return (
    <>
      <div className="mb-4">
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          Report
        </Typography>
        <Typography variant="h4" color="var(--navi-color-gray-c1)">
          {getReportTypeDisplayName(baseReportType)}
        </Typography>
      </div>

      <div className="mb-6">
        <Typography variant="h5" color="var(--navi-color-gray-c2)">
          Team
        </Typography>
        <Typography variant="h4" color="var(--navi-color-gray-c1)">
          {getTeamTypeDisplayName(teamType)}
        </Typography>
      </div>

      <div className="mb-6 w-full flex flex-row items-center justify-center">
        <div
          className="w-full px-4 py-2 bg-[var(--navi-color-gray-bg-secondary)] rounded-lg flex items-center justify-center gap-2 cursor-pointer"
          onClick={() => handleRedirection()}
        >
          <Typography variant="h6" color="var(--navi-color-blue-base)" className="hover:underline">
            View definitions
          </Typography>
          <LinkIcon />
        </div>
      </div>
    </>
  );
};

export default ConfigDrawerInfo;
